export const customizationPages = {
  claims: {
    label: 'Claim Portal',
    icon: { camelCase: 'OutlineCube', kebabCase: 'outline-cube' },
    path: 'claim-portal',
  },
  emails: {
    label: 'Emails',
    icon: { camelCase: 'OutlineEnvelope', kebabCase: 'outline-envelope' },
    path: 'emails',
  },
  widgets: {
    label: 'Widgets',
    icon: { camelCase: 'LineToggleOn', kebabCase: 'toggle-on' },
    path: 'widgets',
  },
  infoModals: {
    label: 'Info Modals',
    icon: { camelCase: 'IconInfo', kebabCase: 'icon-info' },
    path: 'info-modals',
  },
};
